import { render, staticRenderFns } from "./disclaimer2.1.vue?vue&type=template&id=0ac3cf28&scoped=true&"
import script from "./disclaimer2.1.vue?vue&type=script&lang=js&"
export * from "./disclaimer2.1.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer2.1.vue?vue&type=style&index=0&id=0ac3cf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3cf28",
  null
  
)

export default component.exports